import { render, staticRenderFns } from "./documentEmailFetcher.vue?vue&type=template&id=1b60e55e&scoped=true"
import script from "./documentEmailFetcher.vue?vue&type=script&lang=js"
export * from "./documentEmailFetcher.vue?vue&type=script&lang=js"
import style0 from "./documentEmailFetcher.vue?vue&type=style&index=0&id=1b60e55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60e55e",
  null
  
)

export default component.exports